import React from 'react';
import UnifiedProductDetail from '../components/ProductDetail/UnifiedProductDetail';
import { fetchProductById, fetchVariantsByProductRef } from '../services/api/ARSCatalogApi';

const ARSProductDetail = ({ onBack, productId }) => {
    const apiConfig = {
        fetchProduct: fetchProductById,
        fetchVariants: fetchVariantsByProductRef,
        // LINK TO 3D MODEL
        buildModelUrl: (product, variant, productId) => {
            const baseUrl = process.env.REACT_APP_ACTIVE_BASE_URL || 'https://studio.arshades.it';
            return `${baseUrl}/Arshades3dLibrary/${productId}/variant/${variant.id}?fov=15&fovMobile=32`;
        },
        buildVtoUrl: async (product, variant, productId, catalogueId) => {
            if (!product?.mainBrandRef) {
                return (
                    <div style={{
                        width: '100%',
                        height: 'calc(100vh - 13.5rem)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '1.2rem'
                    }}>
                        Impossible to load the Virtual Try-On: mainBrandRef not available
                    </div>
                );
            }

            // Usa dominio fisso webvto.it
            const webDomain = 'webvto.it';
            const brandId = product.mainBrandRef;
            const iframeSrc = `https://${webDomain}/?c=${brandId}&m=${variant.id}&debug=true`;

            return (
                <iframe
                    src={iframeSrc}
                    title="Virtual Try-On"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        overflow: 'hidden',
                        display: 'block'
                    }}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen
                    allow="camera"
                />
            );
        }
    };

    const routeConfig = {
        backRoute: '/ars-catalog',
        catalogueRoute: '/my-catalogues',
        onBack: onBack // Passa la callback personalizzata
    };

    return (
        <UnifiedProductDetail
            apiConfig={apiConfig}
            routeConfig={routeConfig}
            componentName="Product"
            productId={productId}
        />
    );
};

export default ARSProductDetail; 